/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import ErrorIcon from '@material-ui/icons/Error';
import MaskedInput from 'react-text-mask';

import styles from './onBoarding-jss';
import './onBoarding.css';

export const MaskFieldRedux = ({ meta: { touched, error, warning }, input, ...rest }) => (
  <>
    <MaskedInput
      {...rest}
      {...input}
      placeholderChar={'\u2000'}
      error={touched && Boolean(error)}
      className={styles.inputControl}
      InputProps={
        error && {
          endAdornment: (
            <InputAdornment position='end' className='errorIcon'>
              <ErrorIcon />
            </InputAdornment>
          ),
        }
      }
    />

    {(error && <span className='errorMsj'>{error}</span>) || (warning && <span severity='error'>{warning}</span>)}
  </>
);

MaskFieldRedux.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
};

MaskFieldRedux.defaultProps = {
  meta: null,
};
// ................
export const TextFieldRedux = ({ meta: { touched, error, warning }, input, ...rest }) => (
  <>
    <TextField
      {...rest}
      {...input}
      error={touched && Boolean(error)}
      className={styles.inputControl}
      InputProps={
        error && {
          endAdornment: (
            <InputAdornment position='end' className='errorIcon'>
              <ErrorIcon />
            </InputAdornment>
          ),
        }
      }
    />

    {(error && <span className='errorMsj'>{error}</span>) || (warning && <span severity='error'>{warning}</span>)}
  </>
);

TextFieldRedux.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
};

TextFieldRedux.defaultProps = {
  meta: null,
};

export const SelectRedux = ({ input, children, ...rest }) => (
  <Select {...input} {...rest}>
    {children}
  </Select>
);

SelectRedux.propTypes = {
  input: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export const CheckboxRedux = ({ input, ...rest }) => (
  <Checkbox checked={input.value === '' ? false : input.value} {...input} {...rest} />
);

CheckboxRedux.propTypes = {
  input: PropTypes.object.isRequired,
};

export const SwitchRedux = ({ input, ...rest }) => (
  <Switch checked={input.value === '' ? false : input.value} {...input} {...rest} />
);

SwitchRedux.propTypes = {
  input: PropTypes.object.isRequired,
};
